import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09b57e88"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "frisbuy-product-item__image" }
const _hoisted_2 = {
  key: 0,
  class: "frisbuy-similar-title"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "frisbuy-product-item__info" }
const _hoisted_5 = { class: "frisbuy-product-item__text" }
const _hoisted_6 = { class: "frisbuy-product-item__title" }
const _hoisted_7 = {
  key: 0,
  class: "frisbuy-product-item__price"
}
const _hoisted_8 = { class: "frisbuy-product-item__price--actual" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "frisbuy-product-item__currency-symbol" }, " ₽ ", -1))
const _hoisted_10 = {
  key: 0,
  class: "span frisbuy-product-item__price--old"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "frisbuy-product-item__currency-symbol" }, " ₽ ", -1))
const _hoisted_12 = { class: "frisbuy-product-item__buy-button" }
const _hoisted_13 = {
  width: "14",
  height: "18",
  viewBox: "0 0 14 18",
  version: "1.1",
  style: {"fill":"none"}
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "m 0.5,5.5 h 13 V 16 c 0,0.3978 -0.158,0.7794 -0.4393,1.0607 C 12.7794,17.342 12.3978,17.5 12,17.5 H 2 C 1.60218,17.5 1.22064,17.342 0.93934,17.0607 0.658035,16.7794 0.5,16.3978 0.5,16 Z",
  id: "path2",
  style: {"stroke":"#6e6e6e"}
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "m 0.5,5.5 h 13 V 16 c 0,0.3978 -0.158,0.7794 -0.4393,1.0607 C 12.7794,17.342 12.3978,17.5 12,17.5 H 2 C 1.60218,17.5 1.22064,17.342 0.93934,17.0607 0.658035,16.7794 0.5,16.3978 0.5,16 Z",
  id: "path4",
  style: {"stroke":"#6e6e6e"}
}, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M 10,7.5 V 3.533 C 10.0043,2.73301 9.69065,1.96408 9.12806,1.39531 8.56548,0.82654 7.80003,0.5045 7.00004,0.5 6.20005,0.5045 5.4346,0.82654 4.87202,1.39531 4.30944,1.96408 3.99579,2.73301 4.00004,3.533 V 7.5",
  id: "path6",
  style: {"stroke":"#6e6e6e","stroke-linecap":"round","stroke-linejoin":"round"}
}, null, -1))
const _hoisted_17 = [
  _hoisted_14,
  _hoisted_15,
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LikeButton = _resolveComponent("LikeButton")!

  return (_openBlock(), _createElementBlock("a", {
    class: "frisbuy-product-item",
    onClick: _cache[1] || (_cache[1] = ($event) => _ctx.openLink($event, _ctx.product.link))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_LikeButton, {
        onClick: _cache[0] || (_cache[0] = _withModifiers(() => _ctx.likeButtonClick(), ["stop"])),
        isLiked: _ctx.isLiked,
        productArticle: _ctx.product.sku?.vendorCode
      }, null, 8, ["isLiked", "productArticle"]),
      (_ctx.product.isSimilar)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.popupText.similarGood), 1))
        : _createCommentVNode("", true),
      _createElementVNode("img", {
        src: _ctx.getDomainSubstitute(_ctx.product.sku?.picUrl)
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", null, _toDisplayString(_ctx.product.title), 1)
        ]),
        (_ctx.product.sku?.price)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, [
                _createTextVNode(_toDisplayString(_ctx.product.sku.price) + " ", 1),
                _hoisted_9
              ]),
              (_ctx.product.sku?.priceOld)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createTextVNode(_toDisplayString(_ctx.product.sku.priceOld) + " ", 1),
                    _hoisted_11
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("button", _hoisted_12, [
        (_openBlock(), _createElementBlock("svg", _hoisted_13, _hoisted_17))
      ])
    ])
  ]))
}